export enum DeactivationReason {
  STUDENT_OPT_OUT = 'STUDENT_OPT_OUT',
  COURSE_SECTION_DEACTIVATED = 'COURSE_SECTION_DEACTIVATED',
  ADOPTION_DEACTIVATED = 'ADOPTION_DEACTIVATED',
  UNENROLLMENT = 'UNENROLLMENT',
}
